import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-engagement-card-action" }
const _hoisted_2 = { "data-qa": "call-to-action-text" }
const _hoisted_3 = { class: "_shrink-0 _grow-1 _flex _jc-fe" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_notificator = _resolveComponent("base-notificator")

  return (_openBlock(), _createBlock(_component_base_notificator, {
    type: $props.notificatorType,
    "can-close": false,
    class: "_mb-3",
    qa: $props.actionDataQa
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString($props.actionText), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          ($props.canDismiss)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "_pl-0",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.onActionDismiss && $options.onActionDismiss(...args))),
                "data-qa": "notificator-close-btn"
              }, _toDisplayString(_ctx.Resources.Layout.DismissActionButtonText), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_base_button, {
            tag: "a",
            href: $props.actionUrl,
            theme: "transparentInverse",
            onClick: _cache[1] || (_cache[1] = $event => ($options.onAction($event, $props.callback))),
            "data-qa": "notificator-button:"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.actionLabel), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["type", "qa"]))
}